module.exports = __webpack_public_path__ + "static/media/diretor-locacao2.1562e882.png";